import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';

import StaticPage from '~/components/StaticPage';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';

import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import { type StaticPageLoaderData, staticPageLoader } from '../services/static_page';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request }) => {
  return staticPageLoader({
    request,
  });
};

// HACK: This is a placeholder type for components that use the old index page
// loader data. This should prevent any build errors for now.
export type HomePageLoaderData = any;

export const clientLoader = staticPageClientLoader;

const Index = () => {
  const { page, site } = useTypedLoaderData<StaticPageLoaderData>();

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Index;
